import React from 'react'
import CurrentUser from 'components/CurrentUser'
import { Redirect } from 'react-router-dom'

const EnsureAdmin = ({ children, location }) => (
  <CurrentUser
    render={currentUser =>
      currentUser.admin ? children : <Redirect to="/unauthorized" />
    }
  />
)

export default EnsureAdmin



// WEBPACK FOOTER //
// ./src/components/EnsureAdmin.js